import { gql } from '@apollo/client';

const queryGetDatasetShareRequest = (datasetUri: string) => {
    return {
        variables: {
            datasetUri,
        },
        query: gql`
            query GetDataset($datasetUri: String!) {
                getDataset(datasetUri: $datasetUri) {
                    datasetUri
                    name
                }
            }
        `,
    };
};

export default queryGetDatasetShareRequest;
